import { useEffect, useState, useContext, useRef } from "react";
import { PortalContext } from "../../../context/Provider";
import { showToaster } from "../../../../global/context/action/toaster/toaster.js";
import { setUsuario } from "../../../context/Actions/registro/registro";
import { hideModal } from "../../../context/Actions/modal/modal";
import {
  login,
  setUsuarioAuth,
} from "../../../../global/context/action/auth/login";
import { useHistory } from "react-router";
import isPwdValido from "../../../../global/utils/checkPwdValido";
import "./ConfirmarPassword.css";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import {
  vinculaSocial,
  wsGetImagenPerfil,
} from "../../../context/Actions/paciente/paciente";
import HidePassIcon from "../../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../../assets/images/generico/ShowPassIcon";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";

const ConfirmarPassword = ({
  titulo,
  dissmiss,
  texto,
  dni,
  tokenRedSocial,
  idRedSocial,
  redSocial,
}) => {
  const { modalDispatch, registroState, registroDispatch, pacienteDispatch } =
    useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch, configState } = useContext(GlobalContext);

  // Cambio de contexto
  const { authState, authDispatch } = useContext(GlobalContext);

  const history = useHistory();

  const [nuevoPassword, setNuevoPassword] = useState("");
  const [nuevoPasswordError, setNuevoPasswordError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const count = useRef(0);

  const onPasswordPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.target.name === "txtPassword") {
      if (e.key === "Enter") {
        IngresoSistema();
      }
    }
  };

  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const onNuevoPasswordChange = (e) => {
    setNuevoPasswordError(!isPwdValido(e));
    setNuevoPassword(e.target.value);
    if (isPwdValido(e)) {
      setNuevoPassword(e.target.value);
    }
  };

  const IngresoSistema = () => {
    if (nuevoPassword !== "") {
      if (!nuevoPasswordError) {
        let dto = {
          txtDni: dni,
          txtPassword: nuevoPassword,
        };
        login(
          dto,
          configState.config.data.sectorTurno,
          nextStepLogin
        )(authDispatch);
      } else {
        showToaster(
          {
            texto: "Complete el campo requeridos",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    } else {
      showToaster(
        {
          texto: "Complete el campo requeridos",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    document.getElementsByName("txtPassword")[0].focus();
  }, []);

  //manejo nextStep login
  const nextStepLogin = (token, data) => {
    if (token && data !== null && data !== undefined) {
      //seteo una bandera que coloque en usuario para que cuando llegue a perfil, puede distinguir si ingreso para vincular la cuenta
      let usuario = Object.assign({}, registroState.registro.usuario);
      usuario.solicitaRedSoc = true;
      setUsuario(usuario)(registroDispatch);
      wsGetImagenPerfil("", (isCorrect, data) => {
        if (isCorrect) {
          const userDto = {
            ...authState.auth.data,
            paciente: {
              ...authState.auth.data.paciente,
              imagenPerfil: data || null,
            },
          };
          setUsuarioAuth(userDto)(authDispatch);
        }
        vinculaSocial(
          idRedSocial,
          redSocial,
          sessionStorage.token,
          tokenRedSocial
        )(pacienteDispatch);
        history.push("/perfil");
        hideModal()(modalDispatch);
      })(pacienteDispatch);
    }
  };

  // useEffect(() => {
  //   if (authState.auth.data !== null && authState.auth.data !== undefined) {
  //     wsGetImagenPerfil("", (isCorrect, data) => {
  //       if (isCorrect) {
  //         const userDto = {
  //           ...authState.auth.data,
  //           paciente: {
  //             ...authState.auth.data.paciente,
  //             imagenPerfil: data,
  //           },
  //         };
  //         setUsuarioAuth(userDto)(authDispatch);
  //       }
  //     })(pacienteDispatch);
  //     vinculaSocial(
  //       idRedSocial,
  //       redSocial,
  //       sessionStorage.token,
  //       tokenRedSocial
  //     )(pacienteDispatch);
  //     history.push("/perfil");
  //     hideModal()(modalDispatch);
  //   }
  // }, [authState.auth.data]);

  return (
    <>
      <div className="ptur-modal-password modalHeader bgcG-latex30">
        <h1 className="modalTitle rb18b c-white">
          {titulo === "" ? "Error en el sistema" : titulo}
        </h1>
        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </div>
      <div className="modalBody">
        <h3 className="ptur-modal-texto rb16m c-latex10">
          Ingrese la contraseña que utiliza en nuestro Portal
        </h3>
        <h3 className="rb16t c-latex10">{texto === "" ? "" : texto}</h3>
        <div className="ptur-modal-input">
          <InputV1
            headerStr="Contraseña"
            placeholderText="23756"
            inputType="number"
            name="txtPassword"
            errorStr="La contraseña es Inválida."
            onChange={onNuevoPasswordChange}
            onKeyPress={onPasswordPress}
            value={nuevoPassword}
            className={
              passwordShown
                ? "inputNumericShow inputNonScroll rb16m"
                : "inputNumeric inputNonScroll rb16m"
            }
            maxLength="10"
            checkError={nuevoPasswordError}
            isRequired={true}
          />
          {passwordShown === false ? (
            <>
              <button
                className="ptur-modal-passwordConfirm-show-hideBtn"
                onClick={() => showPassword()}
              >
                <HidePassIcon color="var(--color-latex30)" />
              </button>
            </>
          ) : (
            <>
              <button
                className="ptur-modal-passwordConfirm-show-hideBtn"
                onClick={() => hidePassword()}
              >
                <ShowPassIcon color="var(--color-latex30)" />
              </button>
            </>
          )}
        </div>
        <button
          className="btnCambioPassword enviar rb18m"
          onClick={() => IngresoSistema()}
        >
          Ingresar al Sistema
        </button>
      </div>
    </>
  );
};

export default ConfirmarPassword;
